import * as z from 'zod';
import moment from 'moment';

export const dateTimeSchema = z.iso.datetime().transform((str) => moment(str));

export type DateTime = z.infer<typeof dateTimeSchema>;
